const Footer = () => {
    return (
        <>
            <div className="invitation">
                <div className="wrapper">
                    <h2>L’EPSE, c’est pas juste pour les vidéastes !</h2>
                    <p>Plonge dans d’autres domaines et booste ton avenir avec nos formations.</p>
                    <a href="https://www.epse.be" className="btn">Rejoins-nous</a>
                </div>
            </div>
            <footer>
                <div id="service">
                    <div className="wrapper">
                        <div id="footer-epse">
                            <div className="container-logos">
                                <div className="footer-logo">
                                    <img src="/images/epse_footer.svg" alt="logo EPSE" />
                                </div>
                                <div className="footer-logo">
                                    <img src="/images/logo-fwb-negatif.png" alt="logo FWB" />
                                </div>
                                <div className="footer-logo">
                                    <img src="/images/eps_logo_blanc1.png" alt="logo EPS" />
                                </div>
                                <div className="footer-logo">
                                    <img src="/images/fse-v.jpg" alt="logo FSE" />
                                </div>
                            </div>
                            <p>
                                L'EPSE, anciennement <em>Enseignement de Promotion Sociale d'Enghien</em>, est un établissement d'enseignement pour adultes, reconnu et subsidié par la Fédération Wallonie-Bruxelles; membre de la Fédération des Etablissements Libres Subventionnés Indépendants
                            </p>
                        </div>
                        <div id="footer-ecole">
                            <h2>L'ÉCOLE</h2>
                            <a href="https://www.epse.be/a-propos">A propos</a>
                            <a href="https://www.epse.be/AGCF_2_septembre_2015_secondaire_supérieur_type_court.pdf">Règlements</a>
                            <a href="https://www.epse.be/emploi">Emploi</a>
                        </div>
                        <div id="footer-autres">
                            <h2>AUTRES</h2>
                            <a href="https://webmail.webmo.fr/">WebMail</a>
                            <a href="https://moodle.epse.be/login/index.php">Intranet</a>
                            <a href="https://www.epse.be/qualite">Qualité</a>
                            <a href="https://www.epse.be/legal">Légal</a>
                        </div>
                        <div id="footer-social">
                            <h2>SUIS-NOUS</h2>
                            <a className='social-link' href="https://www.linkedin.com/school/epse/" target="_blank">
                                <img src="/images/socials/linked.svg" alt="EPSE LinkedIn" />
                            </a>
                            <a className='social-link' href="https://www.facebook.com/EPSEMarcq/" target="_blank">
                                <img src="/images/socials/facebook.svg" alt="EPSE Facebook" />
                            </a>
                            <a className='social-link' href="https://www.youtube.com/channel/UC33Fs4BdaHlEb5GfDoZzSsA?view_as=subscriber" target="_blank">
                                <img src="/images/socials/youtube.svg" alt="EPSE YouTube" />
                            </a>
                            <a className='social-link' href="https://www.tiktok.com/@e.p.s.e" target="_blank">
                                <img src="/images/socials/tiktok.svg" alt="EPSE TikTok" />
                            </a>
                            <a className='social-link' href="https://www.instagram.com/e.p.s.e/" target="_blank">
                                <img src="/images/socials/insta.svg" alt="EPSE Instagram" />
                            </a>
                            <a href="https://www.epse.be/partenaires" className='partners-link'>Nos Partenaires</a>
                        </div>
                        <div id="footer-contact">
                            <h2>CONTACT</h2>
                            <p><strong>Adresse:</strong><br />Rue du village, 50<br />7850 Marcq</p>
                            <p><strong>Tel:</strong> 02/395.60.23</p>
                            <p><strong>E-mail:</strong> info@epse.be</p>
                            <p><strong>IBAN:</strong> BE67 6352 1578 0187</p>
                        </div>
                    </div>
                </div>
                <div id="f-link">
                    <div className="container">
                        <div id="links">
                            <a href="https://www.epse.be">Accueil</a> | <a href="https://www.epse.be/formations">Formations</a> | <a href="https://www.epse.be/inscription">Inscriptions</a> | <a href="https://www.epse.be/evenements">Evenements</a> | <a href="https://www.epse.be/informations">Infos</a> | <a href="https://www.epse.be/actualites">Actus</a> |  <a href="https://www.epse.be/contact">Contact</a> | <a href="https://moodle.epse.be/login/index.php">Intranet</a>
                        </div>
                        <div id="copy">&copy; EPSE 2025 - Tous droits réservés</div>
                    </div>
                </div>
            </footer>

        </>
     );
}
 
export default Footer;